<template>
  <div class="mxDownload">
    <!-- ios -->
    <div class="ios downloadItem">
      <div class="qrcodeItem" @click="enlargeImg('ios')">
        <div class="default itemContent">
          <img
            class="defaultImg"
            src="../assets/downloadImg/ios-download.png"
            alt=""
          />
        </div>
        <div class="hoverItem itemContent">
          <div class="hoverContent">
            <div class="code-container">
              <canvas ref="iosCode"></canvas>
              <img
                class="mxScanIcon"
                src="../assets/downloadImg/logo2.png"
                alt=""
              />
            </div>
            {{ $t("mx.downloadScan") }}
          </div>
        </div>
        <largeCodeBox class="qrcodeItem-large" v-show="showIOSLarge">
          <div slot="codeSlot">
            <canvas ref="iosLargeCode"></canvas>
            <img
              class="mxScanIcon"
              src="../assets/downloadImg/logo2.png"
              alt=""
            />
          </div>
        </largeCodeBox>
      </div>
      <div class="item_title">{{ $t("mx.ios") }}</div>
    </div>
    <!-- android -->
    <div class="android downloadItem">
      <div class="qrcodeItem" @click="enlargeImg('android')">
        <div class="default itemContent">
          <img
            class="defaultImg"
            src="../assets/downloadImg/android-download.png"
            alt=""
          />
        </div>
        <div class="hoverItem itemContent">
          <div class="hoverContent">
            <div class="code-container">
              <canvas ref="androidCode"></canvas>
              <img
                class="mxScanIcon"
                src="../assets/downloadImg/logo2.png"
                alt=""
              />
            </div>
            {{ $t("mx.downloadScan") }}
          </div>
        </div>
        <largeCodeBox class="qrcodeItem-large" v-show="showAndroidLarge">
          <div slot="codeSlot">
            <canvas ref="androidLargeCode"></canvas>
            <img
              class="mxScanIcon"
              src="../assets/downloadImg/logo2.png"
              alt=""
            />
          </div>
        </largeCodeBox>
      </div>
      <div class="item_title">{{ $t("mx.android") }}</div>
    </div>
    <!-- 鸿蒙next -->
    <div class="harmony downloadItem">
      <div class="qrcodeItem">
        <div class="default itemContent">
          <img
            class="defaultImg"
            src="../assets/downloadImg/harmony-download.png"
            alt=""
          />
        </div>
        <div class="hover-item itemContent">
          <div class="hover-content">
            <div class="contentItem">
              <span style="position: relative">{{ $t("mx.downloadLink") }}</span>
              <!-- {{ $t("mx.harmonyScan") }} -->
              <div class="code-container">
                <!-- hormonyosCode -->
                <canvas ref="hormonyosCode" style="margin-top: -13px"></canvas>
                <img
                  class="mxScanIcon"
                  src="../assets/downloadImg/logo2.png"
                  style="margin-top: -7.5px;"
                  alt=""
                />
              </div>
              <div class="content-tips">
                <span>{{ $t("mx.downloadWithBrowser") }}</span>

              </div>
            </div>
            <div class="contentItem">
              <span>{{ $t("mx.hormony_group") }}</span>
              <!-- {{ $t("mx.harmonyScan") }} -->
              <div class="code-container">
                <img
                  class="harmony-code"
                  src="../assets/downloadImg/harmony-group.png"
                  alt=""
                />
                <img
                  class="mxScanIcon"
                  src="../assets/downloadImg/logo2.png"
                  alt=""
                />
              </div>
              <div class="content-tips">
                {{ $t("mx.harmonyScan") }}
                <div class="group-num">
                  <div>{{ groupNum }}</div>
                  <img
                    class="copy-btn"
                    src="../assets/downloadImg/copy.png"
                    @click="onCopy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item_title">{{ $t("mx.harmony") }}</div>
    </div>
    <!-- mac -->
    <div class="mac downloadItem">
      <div class="qrcodeItem">
        <div class="default itemContent">
          <img
            class="defaultImg"
            src="../assets/downloadImg/mac-download.png"
            alt=""
          />
        </div>
        <div class="hoverItem itemContent" @click="openMacDialog">
          <div class="hoverContent">
            <img
              class="downIcon"
              src="../assets/downloadImg/small-download.png"
              alt=""
            />
            {{ $t("mx.downloadClick") }}
          </div>
        </div>
      </div>
      <div class="item_title">{{ $t("mx.mac") }}</div>
    </div>
    <!-- window -->
    <div class="window downloadItem" @click="download('MeiXin_Pc_Link')">
      <div class="qrcodeItem">
        <div class="default itemContent">
          <img
            class="defaultImg"
            src="../assets/downloadImg/pc-download.png"
            alt=""
          />
        </div>
        <div class="hoverItem itemContent">
          <div class="hoverContent">
            <img
              class="downIcon"
              src="../assets/downloadImg/small-download.png"
              alt=""
            />
            {{ $t("mx.downloadClick") }}
          </div>
        </div>
      </div>
      <div class="item_title">{{ $t("mx.window") }}</div>
    </div>

    <md-dialog :visible.sync="showMacDialog">
      <macDialog :downloadList="mxDownList"></macDialog>
    </md-dialog>
  </div>
</template>
<script>
import QRCode from "qrcode";
import macDialog from "@/components/macDialog";
import largeCodeBox from "@/components/largeCodeBox";
import { is4aLogin } from "@/mx-service/libs/utils";
import { getApiConfig } from "@/mx-service/libs/http/config";
import device from "@/mx-service/libs/utils/device";
import CopyGroupnumber from "./js/copy-groupnumber";

export default {
  components: {
    macDialog,
    largeCodeBox,
  },
  mixins: [CopyGroupnumber],
  props: {
    closeAllLargeBox: Function,
  },
  data() {
    return {
      showMacDialog: false,
      iosqrCodeData: getApiConfig().defaultMobileUrl,
      androidqrCodeData: getApiConfig().defaultMobileUrl,
      hormonyOSCodeData: getApiConfig().hormonyOSDownloadUrl,
      qrCodeOptions: {
        width: 80,
        height: 80,
      },
      qrLargeCodeOptions: {
        width: 140,
        height: 140,
      },
      qrHormonyCodeOptions: {
        width: 187,
        height: 187,
      },
      mxDownList: [],
      showIOSLarge: false,
      showAndroidLarge: false,
      // showHarmonyLarge: false
    };
  },
  methods: {
    // 打开mac的下载提示
    openMacDialog() {
      this.showMacDialog = true;
    },
    // 下载文件
    async download(e) {
      const status = await is4aLogin(e, true);
      let getListStatus = true;
      if (!status) return;
      console.log("下载!!!!! ", status);
      // 请求列表初始化失败情况
      if (!this.mxDownList || this.mxDownList.length === 0) {
        // 重新获取列表数据
        getListStatus = await this.getData();
      }
      const data = this.mxDownList.filter((item) => item.paramId === e)[0];
      window.location.href = data.paramValue;
    },
    async isDownloading() {
      const downloadParamId = this.$route.query.id;
      if (
        (await is4aLogin()) &&
        downloadParamId &&
        downloadParamId.toLowerCase().includes("meixin")
      ) {
        this.download(downloadParamId);
      }
    },
    // 放大二维码
    enlargeImg(type) {
      if (type === "ios") {
        this.showIOSLarge = !this.showIOSLarge;
        this.showAndroidLarge = false;
      } else {
        this.showAndroidLarge = !this.showAndroidLarge;
        this.showIOSLarge = false;
      }
      this.closeAllLargeBox();
    },
    // 缩小全部二维码
    smallImg() {
      this.showAndroidLarge = false;
      this.showIOSLarge = false;
    },
    // 获取列表数据
    async getData() {
      let getListStatus = true;
      try {
        const data = await mx.request("getPcUrl");
        this.mxDownList = data;
        this.iosqrCodeData = this.mxDownList.filter(
          (item) => item.paramId === "MeiXin_ios_Link"
        )[0].paramValue;
        this.androidqrCodeData = this.mxDownList.filter(
          (item) => item.paramId === "MeiXin_Android_Link"
        )[0].paramValue;
      } catch (error) {
        let getListStatus = false;
        this.$MdMessage({
          message: this.$t("netError"),
          type: "warning",
        });
      }
      return getListStatus;
    },
  },
  async mounted() {
    const isMobile = device.isMobile();
    // 判断单点登录状态
    const status = await is4aLogin();
    let getListStatus = true;
    console.log("PC mounted-status", status);
    if (status && !isMobile) {
      getListStatus = await this.getData();
    }
    QRCode.toCanvas(
      this.$refs.hormonyosCode,
      this.hormonyOSCodeData,
      this.qrHormonyCodeOptions,
      function (error) {
        if (error) console.error(error);
      }
    );
    QRCode.toCanvas(
      this.$refs.iosCode,
      this.iosqrCodeData,
      this.qrCodeOptions,
      function (error) {
        if (error) console.error(error);
      }
    );
    QRCode.toCanvas(
      this.$refs.iosLargeCode,
      this.iosqrCodeData,
      this.qrLargeCodeOptions,
      function (error) {
        if (error) console.error(error);
      }
    );
    QRCode.toCanvas(
      this.$refs.androidCode,
      this.androidqrCodeData,
      this.qrCodeOptions,
      function (error) {
        if (error) console.error(error);
      }
    );
    QRCode.toCanvas(
      this.$refs.androidLargeCode,
      this.androidqrCodeData,
      this.qrLargeCodeOptions,
      function (error) {
        if (error) console.error(error);
      }
    );
    // 判断是否有下载进程
    if (getListStatus) await this.isDownloading();
  },
};
</script>
<style lang="less" scoped>
.mxDownload {
  width: 100%;
  // padding: 0 69px 0 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;

  .itemContent {
    background-color: #ffffff;
    border-radius: 12px;
  }

  .downloadItem {
    flex-shrink: 0;
    flex: 0 0 auto;
    width: 110px;
    // height: 120px;
    border-radius: 12px;
    margin: 0 8px;
    height: 240px;

    .qrcodeItem {
      position: relative;
      cursor: pointer;

      .default {
        box-shadow: 0px 1.6px 14.4px 0px rgba(0, 0, 0, 0.05);
      }

      .default,
      .hoverItem {
        width: 110px;
        height: 110px;
        position: relative;
        .defaultImg {
          width: 110px;
          height: 110px;
          border-radius: 12px;
        }
      }
      .hoverItem {
        display: none;
      }
      &:hover .default {
        display: none;
      }
      &:hover .hoverItem {
        display: block;
        // padding: 9.615%;
        box-sizing: border-box;
      }
      .hoverContent {
        position: relative;
        z-index: 49;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 10px;
        color: #333333;
        line-height: 13px;
        background: #ffffff;
        box-shadow: 0px 1.6px 14.4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px;
        overflow: hidden;
        .mxScanIcon {
          width: 18px;
          height: 18px;
          position: absolute;
          // left: calc(50% - 11px);
          // top: calc(50% - 12px);
          background: #fff;
          z-index: 50;
        }
        .downIcon {
          width: 36px;
          height: 36px;
          margin-bottom: 10px;
        }
        // .changeIOSqrcode {
        //   display: flex;
        //   justify-content: center;
        //   align-items: center;
        //   font-size: 9px;
        //   color: #2496FF;
        //   line-height: 13px;
        //   margin-top: 8px;
        //   .changeIcon {
        //     width: 13px;
        //     height: 13px;
        //   }
        // }
        .code-container {
          display: flex;
          align-items: center;
          justify-content: center;
          &.harmony {
            margin-bottom: 7px;
            margin-top: 6px;
            top: 6px;
          }
          .harmony-code {
            height: 65px;
            width: auto;
            object-fit: scale-down;
          }
        }
      }
      .qrcodeItem-large {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.11);
        position: absolute;
        z-index: 80;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // width: 100px;
        // height: 100px;
        // background: red;
        border-radius: 12px;
        canvas {
          border-radius: 12px;
        }
        .mxScanIcon {
          position: absolute;
          z-index: 99;
          width: 30px;
          height: 30px;
          top: calc(50% - 15px);
          left: calc(50% - 15px);
        }
      }
    }
    .item_title {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 18px;
      margin: 16px 0 12px;
      max-width: 110px;
      overflow-wrap: break-word;
      white-space: pre-wrap;
      font-size: 14px;
    }
    .item_configure {
      font-size: 14px;
      color: #2496ff;
      line-height: 18px;
      margin-bottom: 6px;
      cursor: pointer;
    }
  }
  
  .harmony {
    .qrcodeItem {
      cursor: unset !important;
      .hover-item {
        // 临时屏蔽
        display: none;
        width: 420px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -49px;
        z-index: 100;
        .defaultImg {
          width: 110px;
          height: 110px;
          border-radius: 12px;
        }
      }
      // &:hover .default {
      //   display: none;
      // }
      &:hover .hover-item {
        display: block;
        box-sizing: border-box;
      }
      .hover-content {
        display: flex;
        justify-content: center;
        padding: 12px;
        .contentItem {
          position: relative;
          z-index: 49;
          width: 100%;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;;
          align-items: center;
          flex-direction: column;
          font-size: 10px;
          color: #8d8d8d;
          line-height: 18px;
          background: #ffffff;
          flex: 1;
          // box-shadow: 0px 1.6px 14.4px 0px rgba(0, 0, 0, 0.05);
          // border-radius: 12px;
          overflow: hidden;
          white-space: pre-wrap;
          .mxScanIcon {
            width: 44px;
            height: 44px;
            position: absolute;
            background: #fff;
            z-index: 50;
          }
          .downIcon {
            width: 36px;
            height: 36px;
            margin-bottom: 10px;
          }
          .code-container {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 7.5px;
            .harmony-code {
              height: 160px;
              width: auto;
              object-fit: scale-down;
            }
          }
          .group-num {
            display: flex;
            align-items: center;
            justify-content: center;
            .copy-btn {
              margin-left: 8px;
              width: 12px;
              height: 12px;
              position: relative;
              top: -1px;
              cursor: pointer;
            }
          }
          .content-tips {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.md-dialog .el-dialog {
  padding: 0;
  border-radius: 8px;
}
.md-dialog .el-dialog .el-dialog__header {
  padding: 0;
  border: none;
}
.el-dialog {
  width: auto;
  display: inline-block;
}
.md-dialog .el-dialog .el-dialog__headerbtn {
  z-index: 99;
  top: 16px;
  right: 16px;
}
.md-messagebox .el-message-box__message {
  white-space: pre-wrap;
}
</style>
